module.exports = __webpack_public_path__ + "static/media/gilbert.ff30baef.jpeg";